import React from "react";
import Mission from "../../mission";
import Team from "../../team";
import Footer from "../../UI/footer";

function About() {
  return (
    <div className="about">
      <Mission />
      <Team />
      <Footer />
    </div>
  );
}

export default About;
